import tv from "typed-object-validator";
import { EventReservation } from "./Event";
import { Test } from "./Test";
import { User } from "./User";

export type RegistrationStatus = "waiting" | "running" | "done" | "cancelled" | "noshow" | "userCancelled";
export const RegistrationStatusValues: RegistrationStatus[] = ["waiting", "running", "done", "cancelled", "userCancelled", "noshow"];
export const RegistrationStatusSchema = tv
    .value("waiting")
    .or(tv.value("running"))
    .or(tv.value("done"))
    .or(tv.value("cancelled"))
    .or(tv.value("userCancelled"))
    .or(tv.value("noshow"));

export interface Registration {
    testId: number;
    test?: Test;
    userId: number;
    user?: User;
    status: RegistrationStatus;
    createdTimeStamp: number;
    satisfies: boolean;
    reservations?: EventReservation[];
}
